export default {
  state: {
    isShown: false,
    component: null
  },
  mutations: {
    setModalParams(state, params) {
      state.isShown = params.isShown;
      state.component = params.component;
    },
    resetModalParams(state) {
      state.isShown = false;
      state.component = null;
    }
  }
};
